module.exports = __webpack_public_path__ + "static/img/step-4.8b347cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step-4.png
// module id = Gd+U
// module chunks = 1